<template>
  <div>
    <custom-callout
      :border-color="statusColor"
      class-main="mt-3 rounded"
      :controlled="true"
      :has-toggle="canShowHistory"
      :opened="data.isOpen"
      @click:open="onCloseHandler"
    >
      <div class="row py-2">
        <div class="col-12 col-md-2" :class="!isMobile ? 'text-center' : ''">
          <div class="d-flex flex-column color-black mr-2">
            <div v-if="isMobile" class="row">
              <div class="col-10">
                <span
                  :class="
                    `badge badge-pill w-2 font-weight-bold p-2 badge-${statusColor}`
                  "
                />
                <span class="ml-1 font-16">
                  {{ data.estatus | empty }}
                </span>
              </div>
            </div>
            <div v-else class="row w-75 m-auto">
              <div
                :class="
                  `col-12 my-2 badge-pill font-weight-bold font-16 p-2  mx-auto badge-${statusColor}`
                "
              >
                {{ data.estatus | empty }}
              </div>
              <div class="col-12 mt-3">
                <span class="data-title d-block border-mobile text-center">
                  Año Fiscal:
                </span>
                <span class="font-16 color-black font-14">
                  {{ data.fiscalYear | empty }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-10 border-left pl-5">
          <div class="row mb-3">
            <div class="col-12 col-md-2">
              <span class="data-title d-block border-mobile">
                Número de Solicitud:
              </span>
              <span class="font-16 color-black">
                {{ data.requestNumber | empty }}
              </span>
            </div>
            <div class="col-12 col-md-5">
              <span class="data-title d-block">Nombre del Proveedor:</span>
              <span class="font-16 color-black">
                {{ data.companyName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <span class="data-title d-block">Tipo de Proveedor:</span>
              <span class="font-16 color-black">
                {{ data.companyType | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <drop-down
                class="mt-2 actions-dropdown"
                :items="actionItems(data)"
                title="Acciones"
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-md-2">
              <span class="data-title d-block">Fecha de estatus actual:</span>
              <span class="font-16 color-black">
                {{ data.actualStatusDate | date }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <span class="data-title d-block">
                Fecha de sometido de último documento:
              </span>
              <span class="font-16 color-black">
                {{ data.lastDocumentSubmittedDate | date }}
              </span>
            </div>
            <div v-if="isApproved" class="col-12 col-md-2">
              <span class="data-title d-block">Fecha de aprobación:</span>
              <span class="font-16 color-black">
                {{ data.approvalDate | date }}
              </span>
            </div>
            <div v-else class="col-12 col-md-2" />
            <div class="col-12 col-md-5">
              <span class="data-title d-block">
                Cantidad de Documentos Vencidos:
              </span>
              <span class="font-16 color-black">
                {{ amountOverdueDocuments }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="bg-secondary-3 p-2">
          <provider-approval-history
            :items="data.requestHistory.data"
            :show-button="
              data.requestHistory.totalItemCount > 3 &&
                data.requestHistory.totalItemCount != data.requestHistory.count
            "
            @on-load-more="$emit('on-history-load-more')"
          />
        </div>
      </template>
    </custom-callout>

    <div
      v-if="data.isLocked && !data.isLockedByCurrentUser"
      class="locked-banner mt-2"
    >
      <strong>Bloqueado</strong>
      — Perfil en revisión. El proveedor no está disponible para gestión hasta
      concluir el proceso.
      <span v-if="data.lockedByUserName" class="ml-1 text-muted font-13">
        ({{ data.lockedByUserName }})
      </span>
    </div>

    <div v-if="data.isLockedByCurrentUser" class="locked-banner mt-2">
      <strong>Bloqueado por ti</strong>
      — Este proveedor está en tu gestión activa.
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ProviderApprovalHistory from './ProviderApprovalHistory.vue';
import utilities from '@/utils/utilities.js';
import DropDown from 'dropdown';
import store, { modulesName } from '@/store/index';
import companyDeterminationStatus from '@/utils/constants/companyDeterminationStatus.js';
export default {
  name: 'ProviderApprovalResultRow',
  components: {
    CustomCallout,
    DropDown,
    ProviderApprovalHistory,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    statusColor() {
      return utilities.parseStateColorProviderApprovalByStatus(
        this.data.estatusId
      );
    },
    isApproved() {
      return this.data.estatusId == companyDeterminationStatus.Aprobado;
    },
    isMobile() {
      return store.getters[`${modulesName.appModuleName}/getIsMobileDensity`];
    },
    amountOverdueDocuments() {
      return `${this.data.totalDocumentExpired}/${this.data.totalDocument}`;
    },
    actionItems() {
      return () => [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import color-green',
          click: () => this.$emit('enter'),
        },
        {
          label: 'Historial',
          icon: 'fas fa-clock color-green',
          visible: this.canShowHistory,
          click: () => this.onCloseHandler(),
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-red',
          border: 'top',
          click: () => this.$emit('remove'),
        },
      ];
    },
    canShowHistory() {
      return this.userHasPermissions('rempro.providers.approval.history');
    },
    canLock() {
      return this.userHasPermissions('rempro.providers.lock');
    },
  },
  methods: {
    onCloseHandler() {
      this.$emit('on-open-close');
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.border-radius--light {
  border-radius: 0px !important;
}
.badge-green-light {
  background-color: map-get($colors, 'green-light-1');
}
.badge-primary-4 {
  color: map-get($colors, 'white');
  background-color: map-get($colors, 'red');
}
.badge-violet {
  background-color: map-get($colors, 'violet');
}
.badge-yellow {
  background-color: map-get($colors, 'secondary-23');
}
.badge-brown {
  background-color: map-get($colors, 'brown');
}
.badge-orange-light {
  background-color: map-get($colors, 'orange-light');
}
.badge:empty {
  display: inline-block;
}
.badge-gray {
  background-color: map-get($colors, 'gray');
}

@media only screen and (max-width: 768px) {
  .border-left {
    border-left: unset !important;
  }

  .border-mobile {
    border-top: 1px solid #dee2e6 !important;
    margin-top: 1rem;
  }
}
.locked-banner {
  background-color: #ffebeb;
  border: 1px solid #ff5b5c;
  border-radius: 4px;
  padding: 10px;
  color: #ff5b5c;
  font-size: 14px;
}
.actions-dropdown ::v-deep {
  button {
    background-color: transparent !important;
    color: #11291b !important;
  }
}
</style>
